import axios from 'axios';
import { config } from 'react-transition-group';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '',
});

instance.interceptors.request.use((config) => {
    const userInfo = localStorage.getItem('userInfo');

    if(userInfo) {
        const token = JSON.parse(userInfo).token;
        config.headers.Authorization = `Bearer ${token}`
    }

    return config;
})

export default instance;